var _path, _circle, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 41.5H90.5V41V25C90.5 11.469 79.531 0.5 66 0.5H21C9.67816 0.5 0.5 9.67816 0.5 21C0.5 32.3218 9.67816 41.5 21 41.5H90Z",
    fill: "url(#paint0_linear_1494_507)",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_507)",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.33 28L57.212 14.998H58.994L61.832 28H60.336L59.632 24.986H56.442L55.782 28H54.33ZM56.486 24.216H59.61L58.07 16.692L56.486 24.216ZM63.3301 28V14.052H64.6721V28H63.3301ZM67.0039 28V14.052H68.3459V28H67.0039Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16H29.2",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.9004H29.2",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 26.3008H29.2",
    stroke: "white",
    strokeWidth: 1.72,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_507",
    x1: 24.5,
    y1: 11,
    x2: 85,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0C5EB8",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0037B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_507",
    x1: 6.5,
    y1: 10.5,
    x2: 27,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#0D78C5",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023AA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.92,
    height: 12.02,
    fill: "white",
    transform: "translate(12 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllActive);
export default __webpack_public_path__ + "static/media/AllActive.1f8bace87818cb3f5fef831ebbed9315.svg";
export { ForwardRef as ReactComponent };